<template>
  <el-menu class="navbar" mode="horizontal">
    <hamburger class="hamburger-container" :toggleClick="toggleSideBar" :isActive="sidebar.opened"></hamburger>
    <breadcrumb></breadcrumb>
    <span style="position: absolute; right: 90px;" @click="test">
      <span v-if="show_tip">测试环境</span>
      <span style="margin-left: 30px;" v-if="name">{{name}}</span>
      <span style="margin-left: 30px;">{{user_name}}</span>
    </span>
    <el-dropdown class="avatar-container" trigger="click">
      <div class="avatar-wrapper">
        <img class="user-avatar" :src="avatar">
        <i class="el-icon-caret-bottom"></i>
      </div>
      <el-dropdown-menu class="user-dropdown" slot="dropdown">
        <router-link class="inlineBlock" to="/ums/editUserInfo">
          <el-dropdown-item>
            个人资料
          </el-dropdown-item>
        </router-link>
        <router-link class="inlineBlock" to="/">
          <el-dropdown-item>
            首页
          </el-dropdown-item>
        </router-link>
        <el-dropdown-item divided>
          <span @click="logout" style="display:block;">退出</span>
        </el-dropdown-item>
      </el-dropdown-menu>
    </el-dropdown>
  </el-menu>
</template>

<script>
import { mapGetters } from 'vuex'
import Breadcrumb from '@/components/Breadcrumb'
import Hamburger from '@/components/Hamburger'
import {getAgentInfo} from '@/utils/auth'

export default {
  watch:{
    agent_info(newVal,oldVal){
      this.name = newVal.name ? newVal.name : ''
      this.avatar = this.$store.state.user.info.admin.icon
      this.user_name = this.$store.state.user.info.admin.nick_name
    }
  },
  data() {
    return{
     // info:infojs()
     avatar: '',
     name: '',
     user_name: '',
     show_tip: false
    }
  },
  components: {
    Breadcrumb,
    Hamburger
  },
  computed: {
    ...mapGetters([
      'sidebar',
      'agent_info'
    ])
  },
  mounted() {
    if(process.env.BASE_API === 'http://dev.shop.0k24.com/admin/'){
      this.show_tip = true
    }
    this.avatar = this.$store.state.user.info.admin.icon
    this.user_name = this.$store.state.user.info.admin.nick_name
    let agentInfo = localStorage.getItem('agentInfo')
    let data = agentInfo ? JSON.parse(agentInfo) : {};
    if(data && data.name){
      this.name = data.name ? data.name : ''
    }
  },
  methods: {
    test(){
      console.log(this.agent_info);
    },
    toggleSideBar() {
      this.$store.dispatch('ToggleSideBar')
    },
    logout() {
      this.$store.dispatch('LogOut').then(() => {
        location.reload() // 为了重新实例化vue-router对象 避免bug
      })
    },
    logoussst() {
      let arr = getAgentInfo()
      console.log(arr)

    },
  }
}
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
.navbar {
  height: 50px;
  line-height: 50px;
  border-radius: 0px !important;
  .hamburger-container {
    line-height: 58px;
    height: 50px;
    float: left;
    padding: 0 10px;
  }
  .screenfull {
    position: absolute;
    right: 90px;
    top: 16px;
    color: red;
  }
  .avatar-container {
    height: 50px;
    display: inline-block;
    position: absolute;
    right: 35px;
    .avatar-wrapper {
      cursor: pointer;
      margin-top: 5px;
      position: relative;
      .user-avatar {
        width: 40px;
        height: 40px;
        border-radius: 10px;
      }
      .el-icon-caret-bottom {
        position: absolute;
        right: -20px;
        top: 25px;
        font-size: 12px;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/views/layout/components/Navbar.vue